module.exports = __webpack_public_path__ + "img/Group393.162d2b10.svg";